<template>
	<div>
		<div class="slide-page" v-if="currentItem">
			<div class="bg"></div>
			<time-num></time-num>
			<div v-if="type === 1" class="content">
				<div class="imgBox">
					<img :src="currentItem.lowImage1" alt="" srcset="" />
					<img :src="currentItem.lowImage2" alt="" srcset="" />
					<img :src="currentItem.lowImage3" alt="" srcset="" />
					<img :src="currentItem.lowImage4" alt="" srcset="" />
				</div>
			</div>
			<div class="txt mt100">
				这是您的第{{ slideType === 0 ? "一" : "二" }}张玻片，
			</div>
			<div class="txt">接下来请仔细观察并完成作答。</div>
			<div class="footer">
				<!-- <div class="nextquestionactive" @click="$router.replace('/microscope/start')">
					<img class="next1" src="./../../assets/home/previous.png"></img>上一步
				</div> -->
				<div @click="handleGoLuminance" class="left">
					<img src="./../../assets/home/microscopeFalse.png" alt="" />
					开始考核
				</div>
			</div>
			<div class="mask" v-if="isShow"></div>
			<div class="dialog" v-if="isShow">
				<div class="text mt130">您已完成显微镜调试</div>
				<div class="text">将进入正式考核环节</div>
				<div @click="handleClose" class="btn">确认</div>
			</div>
		</div>
		<mi-xin></mi-xin>
	</div>
</template>

<script>
	import {
		mapState
	} from "vuex";
	import MiXin from "../mixins/index";
	import TimeNum from "../mixins/timeNum";
	import {
		submitExamCommitSingerAnswer
	} from "../../api/system/exam";
	export default {
		name: "Home2026",
		components: {
			MiXin,
			TimeNum,
		},
		data() {
			return {
				type: 1,
				isShow: false,
				currentItem: null,
			};
		},
		computed: {
			...mapState("microscope", ["num", "slideType", "slidePaper", "examDetailId", "detail1", "detail2"]),
		},
		mounted() {
			this.currentItem = this.slidePaper[this.slideType];
			this.isShow = this.slideType === 0 ? true : false;
		},
		methods: {
			// 去下一步
			handleGoLuminance() {
				let backendAnswers = {
					paper1Id: this.slidePaper[0].id,
					paper2Id: this.slidePaper[1].id,
					detail1: this.detail1,
					detail2: this.detail2,
				};
				submitExamCommitSingerAnswer({
					backendAnswers: JSON.stringify(backendAnswers),
					paperId: this.slideType,
					questionId: '-1',
					answers: JSON.stringify({
						detail1: this.detail1,
						detail2: this.detail2
					}),
					extractDetailId: this.examDetailId,
				}).then((response) => {
					this.$router.replace("/microscope/luminance");
				});

			},

			// 打开弹出框
			handleClose() {
				this.isShow = false;
			},
		},
	};
</script>

<style lang="less" scoped>
	.slide-page {
		width: 100%;
		min-height: 100vh;
		background-image: url("./../../assets/home/xwjBg.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;

		// .bg {
		//   height: 90px;
		// }
		.content {
			width: 610px;
			margin: 0 auto;
			padding: 20px;
			background: rgba(255, 255, 255, 0.3);
			box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
			border-radius: 60px;
			margin: 0 auto;

			.imgBox {
				display: block;
				width: 610px;
				margin: 0 auto;
				border-radius: 40px;
				overflow: hidden;
				display: flex;
				flex-wrap: wrap;

				img {
					width: 50%;
					border: none;
				}
			}
		}

		.txt {
			line-height: 50px;
			font-size: 32px;
			font-family: HarmonyOS Sans SC;
			font-weight: 400;
			color: #ffffff;
			text-align: center;
		}

		.mt100 {
			margin-top: 100px;
		}

		.footer {
			position: fixed;
			bottom: 0;
			width: 100%;
			height: 143px;
			background: linear-gradient(0deg, #ffffff, #e9f4f2);
			box-shadow: 0px -5px 50px 0px rgba(84, 84, 84, 0.07);
			border-radius: 60px 60px 0px 0px;

			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;

			.left {
				width: 310px;
				height: 88px;
				background: linear-gradient(132.74deg,
						rgba(0, 187, 177, 1) 0%,
						rgba(0, 86, 140, 1) 74.31%,
						rgba(171, 59, 127, 1) 100%);
				border: 1px solid #ffffff;
				box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
				line-height: 88px;
				border-radius: 44px;
				font-size: 35px;
				font-family: HarmonyOS Sans SC;
				font-weight: 500;
				color: #ffffff;

				img {
					width: 40px;
					margin-left: 48px;
					margin-right: 27px;
					vertical-align: middle;
				}
			}
		}

		.mask {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			z-index: 1;
			background: rgba(255, 255, 255, 0.8);
		}

		.dialog {
			width: 612px;
			height: 440px;
			position: fixed;
			z-index: 2;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			margin: auto;

			background: #ffffff;
			box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
			border-radius: 60px;

			.text {
				font-size: 35px;
				font-family: HarmonyOS Sans SC;
				font-weight: bold;
				color: #333333;
				line-height: 60px;
				text-align: center;
			}

			.mt130 {
				margin-top: 120px;
			}

			.btn {
				width: 247px;
				margin: 0 auto;
				height: 80px;
				line-height: 80px;
				text-align: center;
				font-size: 35px;
				font-family: HarmonyOS Sans SC;
				font-weight: 500;
				margin-top: 80px;
				color: #ffffff;
				border-radius: 40px;
				background: linear-gradient(132.74deg,
						rgba(0, 187, 177, 1) 0%,
						rgba(0, 86, 140, 1) 74.31%,
						rgba(171, 59, 127, 1) 100%);
			}
		}
	}

	.nextquestionactive {
		background: linear-gradient(138.51deg, rgba(0, 187, 177, 1) 0%, rgba(0, 80, 137, 1) 79.86%, rgba(171, 59, 127, 1) 100%);
		font-size: 32px;
		color: rgba(255, 255, 255, 1);
		display: flex;
		align-items: center;
		justify-content: center;
		width: 218px;
		height: 88px;
		border-radius: 100px;
		margin-right: 30px;
	}

	.next1 {
		width: 28px;
		height: 24px;
		margin-right: 16px;
	}
</style>